import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { NoDataComponent } from '../NoDataComponent';
import { Invoice } from '../../models/table-models';
import { DashboardInvoice } from './Payments';
import { OptionsProvider } from '../../context/OptionsContext';
import { StepWizardChildProps } from 'react-step-wizard';

interface CustomStepWizardChildProps extends Partial<StepWizardChildProps> {
    fetchHook: () => void;
    unpaidInvoices: Invoice[];
    paidInvoices: Invoice[];
    loading?: boolean;
}

export const Invoices: React.FC<CustomStepWizardChildProps> = ({
    fetchHook,
    unpaidInvoices,
    paidInvoices,
    loading,
}: CustomStepWizardChildProps) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    // Keep the frame while loading so the layout does not jump and an empty list is not mistaken for "no invoices".
    const loader = (
        <div className='d-flex align-items-center justify-content-center px-2' style={{ width: 280, height: '20vh' }}>
            <Spinner animation='border' role='status' />
        </div>
    );

    return (
        <div className='d-flex w-100 align-items-top justify-content-end text-center'>
            <div className='w-90 mb-4'>
                <h5 className='mb-3'>{t('unpaidInvoices') + ':'}</h5>
                <div className={'mx-2 border border-dark'}>
                    {loading ? loader : unpaidInvoices.length > 0 ? (
                        <>
                            <OptionsProvider>
                                <div className={'wrapper-invoices'}>
                                    {unpaidInvoices.map((invoice, index) => (
                                        <DashboardInvoice {...{ invoice, fetchHook, selectedId:invoice.id  }} key={invoice.id} />
                                    ))}
                                </div>
                            </OptionsProvider>
                        </>
                    ) : (
                        <div className='d-flex align-items-center px-2' style={{ width: 280, height: '20vh' }}>
                            <NoDataComponent noDataText={t('payments')}></NoDataComponent>
                        </div>
                    )}
                </div>
            </div>
            <div className='w-90 mb-4'>
                <h5 className='mb-3'>{t('paidInvoices') + ':'}</h5>
                <div className={'mx-2 border border-dark'}>
                    {loading ? loader : paidInvoices.length > 0 ? (
                        <>
                            <OptionsProvider>
                                <div className={'wrapper-invoices'}>
                                    {paidInvoices.map((invoice, index) => (
                                        <DashboardInvoice {...{ invoice, fetchHook, selectedId:invoice.id  }} key={index} />
                                    ))}
                                </div>
                            </OptionsProvider>
                        </>
                    ) : (
                        <div className='d-flex align-items-center px-2' style={{ width: 280, height: '20vh' }}>
                            <NoDataComponent noDataText={t('payments')}></NoDataComponent>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
